<template>
  <main class="image_view_modal" :class="{ on: isOpen }">
    <div class="layer_wrap">
      <header class="header">
        <div class="inner">
          <h1 class="h1">{{ title }}</h1>
          <div class="right">
            <button class="closeImg" v-on:click="$emit('close')">
              <img src="@/assets/front/images/new/i_x.png" />
            </button>
          </div>
        </div>
      </header>
      <div class="img_exp">
        <ul class="img_exp_ul">
          <li class="img_exp_li" v-if="url">
            <pinch-zoom>
              <img :src="require(`@/assets/front/images/${url}`)" alt="" />
            </pinch-zoom>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  name: 'ImageModal',
  data(props) {
    return {};
  },
  async created() {
    // await this.getData();
  },
  methods: {
    // getData() {
    //   const foundType = this.imageData.find(
    //     data => data.type === this.modalType,
    //   );
    //   alert(foundType);
    // },
    // getImage() {
    //   alert('image');
    // },
  },
};
</script>
